import { SMLRouteNames } from '../../../../routing/sml/SMLRoutes';
import { findNavItemForScreen, isDeepScreen, smlHomeNavItem } from '../smlNavigation';

/**
 * What the mobile top bar (768 px and down) shows in its title place for a page (design
 * navigation-v2 7a, 7c, 7f):
 * - `wordmark`: Home and the pages with no menu item show the logo, so the page shows its own title.
 * - `item`: a menu item page shows the item name ("Insights") in the top bar.
 * - `deep`: a page under a menu item shows back + its title (`MobileDeepTopBar`).
 */
export type MobileTopBarTitle = 'wordmark' | 'item' | 'deep';

export function mobileTopBarTitleOf(screen: SMLRouteNames | undefined): MobileTopBarTitle {
  const item = findNavItemForScreen(screen);
  if (item !== undefined && isDeepScreen(item, screen)) {
    return 'deep';
  }
  if (screen === SMLRouteNames.browse || screen === SMLRouteNames.promoteChannels) {
    return 'item';
  }
  return item === undefined || item.id === smlHomeNavItem.id ? 'wordmark' : 'item';
}
